import { Component, OnInit, Input, forwardRef, inject } from '@angular/core';
import { NG_VALUE_ACCESSOR, FormsModule } from '@angular/forms';
import { ReportAbstractOptionComponent } from 'app/shared/components/report-abstract-option/report-abstract-option.component';
import { ReportOption } from 'app/core/models/report-option.model';
import { StoreIdentifierPharmacyPartnerMappingsService } from 'app/core/services/pharmacy-name-mappings.service';
import { NgSelectComponent } from '@ng-select/ng-select';

export class ReportPharmacyPartnerOption implements ReportOption {
  value: string[] | string = null;

  constructor(value) {
    this.value = value;
  }

  toPostData(options = { paramName: 'pharmacyPartnerNames' }) {
    return { [options.paramName]: this.value };
  }
}

@Component({
  selector: 'app-report-pharmacy-partner-option',
  templateUrl: './report-pharmacy-partner-option.component.html',
  styleUrls: ['./report-pharmacy-partner-option.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => ReportPharmacyPartnerOptionComponent),
    },
  ],
  imports: [NgSelectComponent, FormsModule]
})
export class ReportPharmacyPartnerOptionComponent extends ReportAbstractOptionComponent implements OnInit {
  private storeIdentifierPharmacyPartnerMappingsService = inject(StoreIdentifierPharmacyPartnerMappingsService);

  @Input() label = 'Filter by Pharmacy Partners';
  @Input() multiple = true;

  selectedPharmacyPartners: string[] | string;
  pharmacyPartners: string[];

  ngOnInit() {
    this.storeIdentifierPharmacyPartnerMappingsService.getDistinctNames().subscribe(result => {
      this.pharmacyPartners = result;
    });
  }

  protected updateInternalState(model: ReportPharmacyPartnerOption) {
    if (model) {
      this.selectedPharmacyPartners = model.value;
    } else {
      this.selectedPharmacyPartners = [];
    }
  }

  protected determineModelStateOnChange(): ReportPharmacyPartnerOption {
    if (this.selectedPharmacyPartners &&
      (!Array.isArray(this.selectedPharmacyPartners) || this.selectedPharmacyPartners.length > 0)) {
      return new ReportPharmacyPartnerOption(this.selectedPharmacyPartners);
    } else {
      return null;
    }
  }
}
